import { PiniaColada } from '@pinia/colada';
import { createPinia } from 'pinia';
import { createApp } from 'vue';
import { stackFlagsPlugin } from '../shared/config/flags.ts';
import { initFaro } from '../shared/observability/faro.ts';
import App from './App.vue';
import router from './router.ts';
import './styles/styles.css';

initFaro();

const app = createApp(App);

app.use(createPinia());
app.use(PiniaColada);
app.use(router);
app.use(stackFlagsPlugin());
app.mount('#app');
